/**
 *
 *  Apollo Client TypePolicies
 *
 *  To customize how the cache interacts with specific types in the schema,
 *  engineers can provide an object mapping of __typename strings to
 *  TypePolicy objects.
 *
 *  Note that instances of needing to update this file should be uncommon and rare.
 *  In most cases, you can avoid needing to use this file by correctly adding a unique
 *  and exactly named `id` or `_id` field to the objects retrieved in the query. This
 *  is a likely an easier solution as you will not need to maintain a separate setting
 *  for your cache or need to update the client library in your react tree.
 *
 *  When making an update to this file, please provide all the information as to why these
 *  cache settings are needed to correctly cache your query.
 *
 *  More: https://www.apollographql.com/docs/react/caching/cache-configuration/#typepolicy-fields
 *
 */

export * from './utils';
export * from './types';
export default {
  // ...
};